import { runInAction } from 'mobx';
import { updateObject } from '../object-utils';
export const updateFetchedState = (state, newValue) => {
    runInAction(() => updateObject(state, newValue));
};
